
      // Try VITE_APP_NAME first (available via Vite import.meta.env in HTML module scripts)
      const titleFromEnv = import.meta.env.VITE_APP_NAME;
      if (titleFromEnv) {
        document.title = titleFromEnv;
      } else {
        // Fallback: attempt to read a locale JSON quickly to set an initial translated title
        (async () => {
          try {
            const lang = (navigator.language || "en").split("-")[0];
            const supported = ["en", "pl"];
            const locale = supported.includes(lang) ? lang : "en";
            const res = await fetch(`/src/i18n/locales/${locale}.json`);
            if (!res.ok) return;
            const json = await res.json();
            if (json.app && json.app.name) document.title = json.app.name;
          } catch (e) {
            // Ignore errors so a failing locale fetch doesn't block or delay initial page render;
            // the main application bootstrap will handle localization and title later if needed.
          }
        })();
      }
    